<template>
  <div class="h-100">
    <div class="badge-field flex-center flex-column h-100" id="selected-badge-field" tabindex="0">
      <div class="icon-wrapper flex-center">
        <svg-sprite-icon :id="selected.icon" />
      </div>
      <div class="text-prime text-small mt-1 text-gradient bold text-center">
        {{ selected.caption }}
      </div>
    </div>
    <b-popover
      ref="popover"
      custom-class="award-badge-picker"
      boundary="window"
      boundary-padding="20"
      target="selected-badge-field"
      placement="bottomright"
      triggers="click blur"
      :show="true"
      @hidden="selectedPage = PAGES.SELECT_AWARD"
    >
      <div v-if="selectedPage === PAGES.SELECT_AWARD">
        <badges-list class="badges-list" @select="onBadgeSelect($event)" :selected="selected" />
        <div
          class="text-medium-1 add-custom-award pointer thin"
          @click="selectedPage = PAGES.ADD_AWARD"
        >
          Get creative - Create a new custom Award
        </div>
      </div>
      <add-award
        @create="onBadgeSelect($event)"
        @back="selectedPage = PAGES.SELECT_AWARD"
        v-else-if="selectedPage === PAGES.ADD_AWARD"
      />
    </b-popover>
  </div>
</template>

<script>
import { BPopover } from 'bootstrap-vue'
import AddAward from '@/components/award/AddAward'
import SvgSpriteIcon from '@/components/SvgSpriteIcon'
import BadgesList from '@/components/award/BadgesList'

const PAGES = {
  SELECT_AWARD: 'SELECT_AWARD',
  ADD_AWARD: 'ADD_AWARD'
}

/**
 * This component provides a way to select badge for an award. It lets user select a badge (with caption) amongst the predefined set.
 *
 * @emits
 * - change
 */
export default {
  name: 'AwardBadgePicker',
  props: ['selected'],
  components: {
    BPopover,
    AddAward,
    BadgesList,
    SvgSpriteIcon
  },
  data() {
    return {
      selectedPage: PAGES.SELECT_AWARD,
      PAGES
    }
  },
  methods: {
    onBadgeSelect(badge) {
      this.$emit('change', badge)
      this.$refs.popover.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.icon-wrapper {
  @include dimension(65px, 65px);
  background-color: $documentColor;
  border-radius: 50%;
  position: relative;
  &:after {
    content: ' ';
    position: absolute;
    border: 5px solid transparent;
    border-top-color: $prime;
    right: -20px;
    top: 50%;
    transform: translateX(-50%);
  }
}
.badge-field {
  background-color: $selectionColor;
  &:focus {
    outline: none;
  }
}
.add-custom-award {
  padding: 9px 0;
  margin: 0 -20px -20px;
  text-align: center;
  background-color: $selectionColor;
  color: $secondary;
  transition: color ease-in 100ms;
  &:hover {
    color: $primary;
  }
}
.badges-list {
  @include scrollbarWidth($scrollSecondary);

  max-height: 430px;
  overflow: auto;
  padding: 20px 20px 0;
}
</style>
<style lang="scss">
@import '~@/styles/_styleConfigurations.scss';

.award-badge-picker {
  &.popover {
    max-width: 540px;
    overflow: hidden;
  }
  .popover-body {
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
  }
}
</style>
